import { Injectable } from '@angular/core';
import { SealMockApiService } from '@shipsfocus/seal';
import {
  declarationStatuses as declarationStatusesData,
  purposeOfCall as purposeOfCallData,
  vesselCallStatuses as vesselCallStatusesData
} from 'app/mock-api/ship-shore-operation/vessel-call/data';
import cloneDeep from 'lodash-es/cloneDeep';

@Injectable({
  providedIn: 'root'
})
export class VesselCallMockApi {
  private _purposeOfCalls: { id: string; index: number; name: string; slug: string }[] = purposeOfCallData;
  private _vesselCallStatuses: { id: string; index: number; name: string; slug: string }[] = vesselCallStatusesData;
  private _declarationStatuses: { id: string; index: number; name: string; slug: string }[] = declarationStatusesData;

  constructor(private _sealMockApiService: SealMockApiService) {
    this.registerHandlers();
  }

  registerHandlers(): void {
    this._sealMockApiService.onGet('api/ship_shore_operation/vessel_call/purposes').reply(() => {
      const purposeOfCalls = cloneDeep(this._purposeOfCalls);

      return [200, purposeOfCalls];
    });

    this._sealMockApiService.onGet('api/ship_shore_operation/vessel_call/statuses').reply(() => {
      const vesselCallStatuses = cloneDeep(this._vesselCallStatuses);

      return [200, vesselCallStatuses];
    });

    this._sealMockApiService.onGet('api/ship_shore_operation/vessel_call/declaration/statuses').reply(() => {
      const declarationStatuses = cloneDeep(this._declarationStatuses);

      return [200, declarationStatuses];
    });
  }
}
